import { Card } from '@/entities/contract'

import {
  ContractPeriod,
  type Props as ContractPeriodProps,
} from './contract-period'
import {
  GuestInformation,
  type Props as GuestInformationProps,
} from './guest-information'
import {
  HostInformation,
  type Props as HostInformationProps,
} from './host-information'
import {
  RoomInformation,
  type Props as RoomInformationProps,
} from './room-information'

export type Props = RoomInformationProps &
  HostInformationProps &
  GuestInformationProps &
  ContractPeriodProps

export const ContractInformation = ({
  roomName,
  roomUrl,
  addrLot,
  addrStreet,
  picMain,
  hostName,
  hostPhoneNumber,
  hostChatRoomUrl,
  guestName,
  guestPhoneNumber,
  guestChatRoomUrl,
  week,
  startDate,
  endDate,
  roomId,
  contractId,
  isContractDetailPage,
}: Props) => {
  return (
    <Card.Root spacing="large">
      <RoomInformation
        roomName={roomName}
        roomUrl={roomUrl}
        addrLot={addrLot}
        addrStreet={addrStreet}
        picMain={picMain}
        roomId={roomId}
        contractId={contractId}
        isContractDetailPage={isContractDetailPage}
      />
      {isContractDetailPage && (
        <>
          <HostInformation
            hostName={hostName}
            hostPhoneNumber={hostPhoneNumber}
            hostChatRoomUrl={hostChatRoomUrl}
          />
          <GuestInformation
            guestName={guestName}
            guestPhoneNumber={guestPhoneNumber}
            guestChatRoomUrl={guestChatRoomUrl}
          />
        </>
      )}
      <ContractPeriod week={week} startDate={startDate} endDate={endDate} />
    </Card.Root>
  )
}
